import moment from 'moment'
function dateFormat(row, column) {
  if (row[column.property] === null) return ''
  var date = row[column.property].replace('T', ' ')
  if (date === undefined) {
    return ''
  }
  return moment(date).format('YYYY-MM-DD')
}

function datetimeFormat(row, column) {
  if (row[column.property] === null) return ''
  var date = row[column.property].replace('T', ' ')
  if (date === undefined) {
    return ''
  }
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

// 这个函数 网上  随处可见，我也是应用了别人的。
function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      )
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

function disabledDate(time) {
  return time.getTime() >= Date.now() // 禁用以前的日期，今天不禁用
  // return time.getTime() <= Date.now() // 禁用今天以及以前的日期
}
export { dateFormat, datetimeFormat, formatDate, disabledDate }



// WEBPACK FOOTER //
// ./src/plugin/format.js